/**
 * Data grid 2a — pure helpers for multi-row selection. Kept out of the
 * component so the tri-state header logic (none / some / all on the current
 * page) is unit-testable headless.
 */

/** Toggle one id in a selection set, returning a NEW set (immutable). */
export function toggleSelected(selected: Set<string>, id: string): Set<string> {
  const next = new Set(selected);
  if (next.has(id)) next.delete(id);
  else next.add(id);
  return next;
}

/** The header checkbox state for the current page's ids:
 *  - "all"  → every visible row is selected
 *  - "some" → at least one but not all (renders indeterminate)
 *  - "none" → nothing on this page is selected */
export function pageSelectionState(
  pageIds: string[],
  selected: Set<string>,
): "all" | "some" | "none" {
  if (pageIds.length === 0) return "none";
  let n = 0;
  for (const id of pageIds) if (selected.has(id)) n++;
  if (n === 0) return "none";
  return n === pageIds.length ? "all" : "some";
}

/** Select-all / clear-all toggle for the current page: if every visible row is
 *  already selected, remove them; otherwise add them all. Other pages'
 *  selections are preserved. */
export function togglePage(pageIds: string[], selected: Set<string>): Set<string> {
  const next = new Set(selected);
  if (pageSelectionState(pageIds, selected) === "all") {
    for (const id of pageIds) next.delete(id);
  } else {
    for (const id of pageIds) next.add(id);
  }
  return next;
}
